// removed by extract-text-webpack-plugin
module.exports = {"container_chart":"_33DW_05XZrLG2bML0JedvG","container_stats":"_22ombUcPS055rMrhVmkDu4","container_visited":"_20J9qk_wKq_6WS77nwCc3u","container_top3":"_2YJysawBsyDpdLHaZIjbQs","TitleQrcode":"_2dlqdvoA2n6FstCVx3ij71","linkWebsite":"_3LhwYWRXhXGDSJmLwDMrue","card_body":"_112cCOPZjWLDPVy1V-QBTH","icon_edit_stats":"_1173X8aROVw_CsntvJGPej","NumberVisite":"_3_LaRCX96jXuvXdhK5G9V5","iconQrcode":"_39GYGEpkIKSFBGpifEl8Xa","container_stats_annuel":"_3EH8FLgPfu3rvrmmrL5Rvv","text_stats_annuel":"_1zZXPsgRHKT67SYIj-nFdp","container_graph":"_3KKk7k105toJXvHZuetNOn"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/admin/stats/stats.scss
// module id = 1637
// module chunks = 0